import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { FrontOffService,MasterService } from '../../services/index';

import { AppGlobals } from '../../shared/app.global';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { ChartType } from 'chart.js';
import { MultiDataSet } from 'ng2-charts';
import { ChartDataSets , RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {  ChartOptions } from 'chart.js';
import { Color} from 'ng2-charts';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  providers:[FrontOffService,AppGlobals,MasterService]
})
export class RegisterComponent implements OnInit {

   studentarr:any[];
    depts:any[];
    catgories:any[];
   
    @ViewChild('dt') table: any;
    closeResult: string;
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
    classes:any=[];
    sections:any=[];
    bloodgp:any=[];
    objfrm:any={};
    castecats:any=[];
    arrnotif:any=[];
    subcomb:any=[];
    oprtype:string;
    filtcatgory:any[];
    arhouse:any=[];
    aylist:any[];
    arpayopt:any=[];
    arfeequota1:any=[];
    arfeequota:any=[];
    arfeequotatp:any=[];
    arfeequotahs:any=[];
    armot:any=[];
    arrcourse:any=[];
    objstudent:any;
    admdash:any={};
    arrmtongue:any=[];
    objregdata:any={};
    objtcinfo:any={};
    arrstudoctype:any=[];
    stuclass:any=[];
    stuclassnew:any=[];
    stucourse:any=[];
    stufee:any=[];
    stuid;
    alclnew:boolean=true;
    alcrnew:boolean=true;
    defctype:any;
    catwiseissued:any=[];
    arrstatus=[{name:'Active'},{name:'Inactive'},{name:'Old'}];
    arropted=[{name:'Yes'},{name:'No'}];
    arrscst=[{name:'SC'},{name:'ST'},{name:'NO'}];
  
    arrcerftypes:any=[];
    arrformats:any=[];
  
      arrclass:any[]=[];
  arrclass1:any[]=[];
  arrcourse1:any[]=[];
  stucoursenew:any=[]
   
    //=[{'id':'1','name':'English'},{'id':'2','name':'Hindi'}];
    tab=1;
    tab1=1;
    selcat:any=0;
    verifiedstatus:any;
    genders:any=[{value:'Male',name:'Male'},{value:'Female',name:'Female'},{value:'Trans',name:'Trans'}];
    statuses:any=[{value:'Active',name:'Active'},{value:'Inactive',name:'Inactive'},{value:'Old',name:'Old'}];
  
    fileToUpload: File = null;
  
  fData: FormData = new FormData;
  dcid:any=0;
  arrstudoc:any=[];
  disuploadbtn=true;
  objbulkfilter:any={};
  arrfields:any=[];
  arrstulist:any=[];
  objfieldsel:any={};
  arrinst:any=[];
  defclass:any=0;
  defcorse:any=0;
  defsec:any='0';
  defstat='Active';
  studentarr1:any=[];
  arrsections:any=[];
  arrbatch:any=[];
  instype:any='';
  objfeesum:any={};
  arrfeerecs:any=[];
  // stuid:any;
  
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
        position: 'left',
      },
  };
  
  public catChartLabels: Label[] ;
  public catChartData: SingleDataSet ;
   public procureChartLabels: Label[] ;
   public procureChartData: SingleDataSet ;
   public procureChartType: ChartType = 'doughnut';
   public procureChartLegend = true;
   public procureChartPlugins = [];
   public procureChartColors: Color[] = [
     {backgroundColor:["#FF00CC","#0033FF","#99CC00","#FF3333","#FFFF66","#5EE8C6","#5EC2E8","#AF5EE8","#5EE8A1","#9505F9","#F9A005","#F90595","#BC3210","#A5E2ED"]},
     // {backgroundColor:["#9E120E","#FF5800","#FFB414"]},
     // {backgroundColor:["#9E120E","#FF5800","#FFB414"]}
   ];
  
  
   barChartData1:ChartDataSets[]=[{data:[]}];
   
   barChartOptions: ChartOptions = {
    responsive: true,
    scales: { //you're missing this
      yAxes: [{
         scaleLabel: {
            display: true,
            labelString: 'Attendance (%)'
            // beginAtZero: true,
         },
         ticks: {
          // stepSize: 2,
          beginAtZero: true,
          max:100,
          min:0
       }
      }]
   }//END scales
  };
  barChartLabels: Label[] = [];
  barChartLabels1: Label[] = [];
  barChartType: ChartType = 'bar';
  barChartLegend = true;
  barChartPlugins = [];
  walkinChartColors: Color[] = [
    {
      
      backgroundColor: '#F1670D',
      
    },
    ,
    {
     
      backgroundColor: '#0033FF',
    },
  ];
  arrmoe: any;
  arradmyr: any;
    //modalOption: NgbModalOptions = {};
    //filteredOptions: Observable<any[]>;
    constructor(private http: HttpClient, private mservice:MasterService,private fservice: FrontOffService,private modalService: NgbModal,private apglobal:AppGlobals) {
  
    
     }
  
   
  
   
  
      
  
    ngOnInit(): void {
     
     //this.getadmindashcounts();
     this.instype=localStorage.getItem('instype');
      this.getstudents('s',0);
      this.masclass();
      this.massection();
      this.masbloodgroup();
      this.mascastecat();
      // this.massubcomb();
      this.masacademicyears();
      // this.mashouse();
      // this.maspayopts();
      // this.masfeequota();
      this.masmot();
      this.mascourse();
      // this.masmtongue();
      // this.getinstite();
      // this.selbatch();
      this.masgeneral("Admission mode");
      this.masadmyear();
      
  
    }
   
    chartcatcirculation()
  {
    var oprtype="";
    if(this.instype == "School")
    {
      oprtype="attsc";
      this.fservice.stuprofile(oprtype,this.stuid)
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      this.catwiseissued=resultArray;
  
      //this.mutitest();
     // this.dataSource = new MatTableDataSource(resultArray);
     var arr = []
     var labelarr=[];
  
  
     for ( var i = 0; i < resultArray.length ; i++) {
      //console.log('multiarray -i',JSON.stringify(i));
       
            
      labelarr.push(resultArray[i].name);
           
      arr.push(parseInt( resultArray[i].cnt));    
           
    }
      
     
      this.catChartLabels = labelarr;
     this.catChartData = arr;
     
     console.log("pieChartData ", this.catChartLabels);
      },
     error => console.log("Error :: " + error)
  )
    }
  
    else{
      oprtype="attcl";
  
   
       
      this.fservice.stuprofile(oprtype,this.stuid)
      .subscribe(
        
       resultArray =>{
          var arr = [];
          var issued = [];
          var returned = [];
          for ( var i = 0; i < resultArray.length ; i++) {
            //console.log('multiarray -i',JSON.stringify(i));
             
                  
                  arr.push(resultArray[i].sunm);
                  issued.push(parseInt( resultArray[i].perc)); // 
                  // returned.push(parseInt( resultArray[i].stfcnt));
                  
                 
          }
         
         this.barChartData1 = [
            { data: issued, label: 'Subject wise Attendance', barThickness: 15,
           }
          ];
           this.barChartLabels1 = arr;
        
          },
          error => console.log("Error :: " + error)
       )
       
      }
    
    
    
    }
    
    
  
  
    
    masgeneral(tag) {
      this.mservice.masgeneral(tag)
          .subscribe(
          resultArray => {
              console.log('arrmtongue', resultArray);
              if (tag=='Student Docs')
              {
              this.arrstudoctype = resultArray;
              this.dcid=this.arrstudoctype[0].gcd;
              
              }
    
              else if (tag=='Admission mode')
              {
              this.arrmoe = resultArray;
              }
             
          },
          error => console.log("Error :: " + error)
          )
    }
  
  
    feepayments(tag) {
      this.fservice.stuprofile(tag,this.stuid)
          .subscribe(
          resultArray => {
              console.log('arrmtongue', resultArray);
              if (tag=='feesum')
              {
              this.objfeesum = resultArray[0];
              this.feepayments("feerects");
              }
    
              else if (tag=='feerects')
              {
              this.arrfeerecs = resultArray;
              }
             
          },
          error => console.log("Error :: " + error)
          )
    }
   
  
  getdashcounts() {
    // this.liservice.booksdashcounts()
    //     .subscribe(
    //     resultArray => {
    //         console.log('getdashcounts', resultArray);
    //         this.dashcount = resultArray[0];
           
    //     },
    //     error => console.log("Error :: " + error)
    //     )
  }
  
  onbulkupdateclick()
  {
    this.objbulkfilter.clid=this.classes[0].clid;
    this.objbulkfilter.scid=this.sections[0].scid;
    this.objbulkfilter.crid=this.arrcourse[0].crid;
    this.getstudent_dbfields();
    //this.onchangefield();
  }
  
  
  getstudent_dbfields() {
    this.fservice.getstudent_dbfields()
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arrfields = resultArray;
            this.objbulkfilter.fieldnm=resultArray[0].fieldnm;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  
  getstudentsdata() {
    debugger;
    this.fservice.getstudents_clwise(this.objbulkfilter.clid,this.objbulkfilter.scid,this.objbulkfilter.crid)
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arrstulist = resultArray;
            
           
        },
        error => console.log("Error :: " + error)
        )
  }
  onchangefield()
  {
    debugger
    var selflvalue=this.objbulkfilter.fieldnm;
    this.objfieldsel= this.arrfields.find(xx => xx.fieldnm === selflvalue);
    console.log('selec',this.objfieldsel);
    this.getstudentsdata();
  
  }
  
  onbsave()
  {
    console.log('onbsave',this.arrstulist);
  
  }
  masbloodgroup() {
    this.fservice.masbloodgroups()
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.bloodgp = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  mascastecat() {
    this.fservice.mascastecat()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.castecats = resultArray.filter(item => item.active==='Yes')
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  masmtongue() {
    this.mservice.getmasmtongue()
        .subscribe(
        resultArray => {
            console.log('arrmtongue', resultArray);
            this.arrmtongue = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  massubcomb() {
    this.fservice.massubcomb()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.subcomb = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  getinstite() {
    this.fservice.getinstite()
        .subscribe(
        resultArray => {
            console.log('institutes', resultArray);
            this.arrinst = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  masacademicyears() {
    this.fservice.masacademicyear()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.aylist = resultArray;
  
            //this.aylist.sort((a, b) => parseInt(a.ayid).localeCompare(parseInt(b.ayid))
            this.aylist.sort((a, b) => {
              return parseInt(b.ayid)-parseInt(a.ayid);
            });
           
        },
        error => console.log("Error :: " + error)
        )
  }
  masclass() {
    debugger
    this.fservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
            this.arrclass1=resultArray;
  //this.arrclass1.unshift({clid:"0",clnm:"ALL"});
  //this.arrclass1.shift();
  this.defclass="0";
  console.log('masclass', this.arrclass1);     
        },
        error => console.log("Error :: " + error)
        )
  }
  massection() {
    this.fservice.massection()
        .subscribe(
        resultArray => {
            console.log('sections', resultArray);
            this.sections = resultArray;
            this.arrsections = resultArray;
           // this.arrsections.unshift({scid:"0",sccd:"ALL"});
            this.defsec="0";
        },
        error => console.log("Error :: " + error)
        )
  }
  
  selbatch()
  {
    debugger
    this.mservice.selbatch()
    .subscribe(
    resultArray =>{
      //console.log('sub-result', resultArray);
      this.arrbatch=resultArray;
      //this.objfilt.baid=resultArray[0].baid;
      },
  error => console.log("Error :: " + error)
  )
  }
  mashouse() {
    this.fservice.mashouse()
        .subscribe(
        resultArray => {
            console.log('arhouse', resultArray);
            this.arhouse = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  mascourse() {
    this.fservice.mascourse()
        .subscribe(
        resultArray => {
            console.log('arcourse', resultArray);
            this.arrcourse = resultArray;
            this.arrcourse1=resultArray;
   // this.arrcourse1.unshift({crid:"0",crnm:"ALL"});
           this.defcorse="0";
        },
        error => console.log("Error :: " + error)
        )
  }
  
  onchangefilters()
  {
    debugger
  if(this.defclass=="0" && this.defcorse=="0" && this.defsec=="0" )
  {
  
    this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat);
  }
  
  else if(this.defclass!="0" && this.defcorse!="0" && this.defsec!="0"  )
  {
  
    this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass && item.crid===this.defcorse && item.scid===this.defsec);
  }
  
  // else if(this.defclass!="0" && this.defcorse!="0" )
  // {
  
  //   this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass && item.crid===this.defcorse);
  // }
  
  else if(this.defclass!="0" && this.defsec!="0"  && this.defcorse==="0" )
  {
  
    this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass && item.scid===this.defsec);
  }
  
  else if(this.defclass==="0" && this.defsec!="0" && this.defcorse!="0" )
  {
  
    this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.crid===this.defcorse && item.scid===this.defsec );
  }
  
  else if(this.defclass!="0" && this.defsec==="0"  && this.defcorse==="0" )
  {
  
    this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass );
  }
  
  
  else if(this.defclass==="0" && this.defsec==="0" && this.defcorse!="0" )
  {
  
    this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.crid===this.defcorse  );
  }
  
  else if(this.defclass!="0" && this.defsec==="0"  && this.defcorse!="0" )
  {
  
    this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass && item.crid===this.defcorse);
  }
  
  // else if(this.defclass!="0" && this.defsec!="0"  && this.defcorse!="0" )
  // {
  
  //   this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass && item.crid===this.defcorse && item.scid===this.defsec);
  // }
    //if()
  
    console.log('studentarr',this.studentarr);
  }
  
  
  
  // getadmindashcounts() {
  //   this.fservice.getdashconts()
  //       .subscribe(
  //       resultArray => {
  //           console.log('arcourse', resultArray);
  //           this.admdash = resultArray[0];
           
  //       },
  //       error => console.log("Error :: " + error)
  //       )
  // }
  
  studentoverview() {
    this.fservice.studentoverview()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.stuclass = resultArray.arrclass;
            this.stucourse = resultArray.arrcourse;
            this.stucoursenew = resultArray.arrcoursenew;
            this.stufee = resultArray.arrfquota;
            this.stuclassnew = resultArray.arrnewclass;
  
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  exportrecord(tag,tag1){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     //var url=this.liservice.callurl+"export/expstudent.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype+"&clid="+this.defclass+"&crid="+this.defcorse;
     var url=this.fservice.callurl+"export/expstudent.php?clcd="+clcd+"&aycd="+aycd+"&alclnew="+tag+"&tag="+tag1+"&crid="+this.defcorse+"&clid="+this.defclass+"&scid="+this.defsec+"&stustatus="+this.defstat;
  
     window.open(url,'','');
   }
  
   printidinfo(){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     //var url=this.liservice.callurl+"export/expstudent.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype+"&clid="+this.defclass+"&crid="+this.defcorse;
     var url=this.fservice.callurl+"fpdf181/pdfreports/studentinfo.php?clcd="+clcd+"&aycd="+aycd+"&crid="+this.defcorse+"&clid="+this.defclass+"&scid="+this.defsec;
  
     window.open(url,'','');
   }
  
  masfeequota() {
    this.fservice.masfeequota()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arfeequota1 = resultArray;
            this.arfeequota = resultArray.filter(item=>item.accatid==1);
            this.arfeequotatp = resultArray.filter(item=>item.accatid==2);
            this.arfeequotahs = resultArray.filter(item=>item.accatid==5);
           
        },
        error => console.log("Error :: " + error)
        )
  }
  maspayopts() {
    this.fservice.maspayopt()
        .subscribe(
        resultArray => {
            console.log('maspayopt', resultArray);
            this.arpayopt = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  
  
  masmot() {
    this.fservice.masmot()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.armot = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  ontypechange(admtype)
  {
    if(admtype=='R')
    {
this.objstudent.adyrid='1';
    }

    else 
    {
this.objstudent.adyrid='2';

    }

  }
  composefiltercategory(jstring)
  {
    var newstr = jstring.replace(/bkcatid/g, "value"); 
    var newstr = newstr.replace(/bkcatnm/g, "label"); 
    console.log('jsonrep',newstr);
    let resJSON = JSON.parse(newstr);
    var arr=Array.of(resJSON);
    let objval:any={};
    objval.label='All';
    objval.value='0';
    objval.status=0;
    arr[0].splice(0, 0, objval);
    this.filtcatgory=arr[0];
    console.log('filtcatgory',this.filtcatgory);
  }
  
  
  getstudents(oprtype,stuid) {
    this.fservice.getstudents(oprtype,stuid)
        .subscribe(
        resultArray => {
            console.log('getlibdepartment', resultArray);
            this.studentarr = resultArray.stulst;
            this.studentarr1 = resultArray.stulst;
  
            this.admdash=resultArray.studash;
            this.onchangefilters();
            
        },
        error => console.log("Error :: " + error)
        )
  }
  
  printidcard(memid,type,tag){
    debugger
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.fservice.callurl+"qrcode/"+type+".php?clcd="+clcd+"&aycd="+aycd+"&memid="+memid+"&tag="+tag+"&clid="+this.defclass+"&crid="+this.defcorse+"&tag1=stu"
     window.open(url,'','');
   }
  
  
   printcertificate(student,flnm,content){
    debugger
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
  
    if (this.defctype=="3")
    {
      this.objfrm=flnm;
      this.getstudentdata('s_id',student.stuid)
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'xl'
       }
      this.modalRef=this.modalService.open(content,this.modalOptions);
     
       this.modalRef.result.then((result) => {
      
            // this.Asmtdetls(asid);
             this.closeResult = `Closed with: ${result}`;
         }, (reason) => {
             this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
         });
        
    }
    else{
     var url=this.fservice.callurl+flnm.filename+"?clcd="+clcd+"&aycd="+aycd+"&stuid="+student.stuid+"&clid="+student.clid+"&format="+flnm.frmid;
  
     window.open(url,'','_blank');
    }
   }
  
  
  closedocument_dialog()
  {
  
    this.getstudents('s',0);
  }
  
  Saveadmissioninfo(objstudent)
  {
    debugger;
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
   
    console.log(JSON.stringify(objstudent));
    
  
    this.fservice.save_admission_reg(objstudent)
    .subscribe(result => {
        console.log('ret',JSON.stringify(result));
        alert (result.message);
        if(result.status=='Success')
  {
    let localmodref=this.modalRef;
  localmodref.close();
  this.getstudents('s',0);
  
  
  }
        //this.alertmessage=result.message;
    
   // this.Getclasslist();
    }, error => 
    alert('error in connection')
  
    
    //this.alertmessage='error in connection'
    );
  
  }
  
  
  
  savedetails()
  {
    debugger;
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    console.log(JSON.stringify(this.objtcinfo));
    
  
    this.fservice.savetcdetails(this.objtcinfo)
    .subscribe(result => {
        console.log('ret',JSON.stringify(result));
        alert (result.message);
        if(result.status=='Success')
  {
    let localmodref=this.modalRef;
  localmodref.close();
  this.getstudents('s',0);
  var url=this.fservice.callurl+this.objfrm.filename+"?clcd="+clcd+"&aycd="+aycd+"&stuid="+this.objtcinfo.stuid+"&clid="+this.objtcinfo.clid+"&format="+this.objfrm.frmid;
  
     window.open(url,'','_blank');
  }
        //this.alertmessage=result.message;
    
   // this.Getclasslist();
    }, error => 
    alert('error in connection')
  
    
    //this.alertmessage='error in connection'
    );
  
  }
  
  getstudentdata(oprtype,stuid) {
    console.log('stuid', stuid);
    this.fservice.getstudents_reg(oprtype,stuid)
        .subscribe(
        resultArray => {
            console.log('getlibdepartment', resultArray);
            this.objstudent = resultArray.stulst[0];
            this.objtcinfo=resultArray.stulst[0];
            console.log('objstudent', this.objstudent);
            this.objstudent.oprtype='update';
            
        },
        error => console.log("Error :: " + error)
        )
  }
  applybooksFilter(filterValue: string) {
    // filterValue = filterValue.trim(); // Remove whitespace
    // filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  
    // if(filterValue.length>=3)
    // {
  //     debugger
  //     var oprtype='allbook';
  //     var bkcat=0;
  //     if (this.selcat==0||this.selcat=='0')
  //     {
  //       oprtype='allbook';
  //       bkcat=0;
  //     }
  
  //     else
  //     {
  //       oprtype='serbycat';
  //       bkcat=this.selcat;
  //     }
  //   this.liservice.serchbooks(filterValue,oprtype,bkcat)
  //   .subscribe(
  //   resultArray => {
  //       console.log('books-result', resultArray);
  //       this.bookdetails = resultArray;
  //     // this.authorfilter();
        
  //   },
  //   error => console.log("Error :: " + error)
  //   )
  // }
  // else 
  // {
  //   this.getbookdetails();
  // }
  
  }
  
  
  openbookdialog(content,formdata,cmd) {
    debugger
    console.log("formdata",formdata);
  
    this.oprtype=cmd;
    if(cmd=='insert')
    {
       this.objstudent={};
       this.objstudent.stuid=0;
       this.objstudent.stunm='';
       
       
      
       this.objstudent.dob=this.apglobal.getdatetoday();
       this.objstudent.gender='Male';
       this.objstudent.bgid='1';
       this.objstudent.mtid='0';
       this.objstudent.qcryop='';
       this.objstudent.nationality='Indian';
       this.objstudent.religion='.';
       this.objstudent.caste='.';
       this.objstudent.subcaste='.';
       this.objstudent.stumobile='';
       this.objstudent.stuemail='';
       this.objstudent.fatnm='';
       this.objstudent.parincome='0';
       this.objstudent.fatprof='';
       this.objstudent.fatedu='';
       this.objstudent.fatmobile='';
       this.objstudent.motemail='';
       this.objstudent.motmobile='';
       this.objstudent.motnm='';
       this.objstudent.motprof='';
       this.objstudent.motedu='';
  this.objstudent.admtype='R';
  this.objstudent.stutype='K';
       this.objstudent.adyrid='1';
  
       
       this.objstudent.address='';
       this.objstudent.coraddress='';
       this.objstudent.peraddress='';
       this.objstudent.citytype='Urban';
     
       this.objstudent.state='';
      
  
       this.objstudent.addt=this.apglobal.getdatetoday();
     
        this.objstudent.moa=this.arrmoe[0].gcd;
       this.objstudent.adayid=this.aylist[0].ayid;
       
       
       this.objstudent.aadhaar='';
       
       this.objstudent.catid='1';
       
      //  this.objstudent.clid=this.classes[0].clid;
      //  this.objstudent.scid=this.sections[0].scid;
       this.objstudent.regno=0;
      //  this.objstudent.sucbid=this.subcomb[0].sucbid;
      
       this.objstudent.crid='1';
       this.objstudent.adno='';

        this.objstudent.sslcstuinkar='Y';
         this.objstudent.sslcstuinstate='';
          this.objstudent.sslcregno='';
           this.objstudent.sslcpassyrmn='';
            this.objstudent.sslcscored='';
             this.objstudent.sslcmaxscore='';
              this.objstudent.pucstuinkar='Y';
              this.objstudent.pucstate='';
              this.objstudent.pucregno='';
              this.objstudent.pucpasyrmn='';
              this.objstudent.pucscored='';
              this.objstudent.pucmaxscore='';
              // this.objstudent.sslcmaxscore='';
       this.objstudent.stustatus='Active';
       this.objstudent.oprtype=cmd;
       
      this.objstudent.coresub1='';
      this.objstudent.coresub2='';
      this.objstudent.coresub3='';
      this.objstudent.coresub1marks='';
      this.objstudent.coresub2marks='';
      this.objstudent.coresub3marks='';
      this.objstudent.coresubttl='';
      this.objstudent.coresubavg='';
      // this.objstudent.penno='';
      
    }
    else if (cmd=='update')
    {
      this.getstudentdata('s_id',formdata)
      // this.objstudent=formdata;
      // this.objstudent.oprtype=cmd;
  
    }
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'xl'
     }
    this.modalRef=this.modalService.open(content,this.modalOptions);
   
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
      
    
  }
  
  
  openmemdialog(content,formdata,cmd) {
    console.log("formdata",formdata);
  
    this.oprtype=cmd;
    if(cmd=='insert')
    {
      this.objregdata={};
      this.objregdata.stuid=0;
      this.objregdata.stunm='';
      this.objregdata.ayid=this.aylist[0].ayid;
      
     
      this.objregdata.dob=this.apglobal.getdatetoday();
      this.objregdata.gender='Male';
      this.objregdata.bgid='1';
   
     
      this.objregdata.nationality='Indian';
      this.objregdata.religion='.';
      this.objregdata.caste='.';
     
      this.objregdata.stumobile='';
      this.objregdata.stuemail='';
      this.objregdata.fatnm='';
      this.objregdata.parincome='';
      this.objregdata.fatprof='';
      this.objregdata.fatedu='';
      this.objregdata.fatmobile='';
      this.objregdata.motemail='';
      this.objregdata.motmobile='';
      this.objregdata.motnm='';
      this.objregdata.motprof='';
      this.objregdata.motedu='';
  
  
      
      this.objregdata.address='';
   
      this.objregdata.state='';
     
  
      this.objregdata.addt=this.apglobal.getdatetoday();
      // this.objregdata.vldt=this.apglobal.getdatetoday();
      // this.objregdata.feqtid=this.arfeequota[0].feqtId;
      this.objregdata.adayid=this.aylist[0].ayid;
      this.objregdata.payoptid='1';
      
      this.objregdata.aadhaar='';
      
      this.objregdata.catid='1';
      this.objregdata.adclid=this.classes[0].clid;
      this.objregdata.clid=this.classes[0].clid;
      this.objregdata.scid=this.sections[0].scid;
      this.objregdata.regno=0;
      // this.objregdata.sucbid=this.subcomb[0].sucbid;
      // this.objregdata.rollno='0';
      // this.objregdata.hsid='0';
      this.objregdata.crid='1';
      this.objregdata.usid='';
      this.objregdata.stustatus='Active';
      this.objregdata.oprtype=cmd;
      this.objregdata.enid=0;
  
      this.objregdata.tpreq='No';
      this.objregdata.payoptidtp='0';
      this.objregdata.feqtidtp='0';
      this.objregdata.htreq='No';
      this.objregdata.payoptidht='0';
      this.objregdata.feqtidht='0';
      this.objregdata.penno='';
      
    }
    else if (cmd=='update')
    {
      this.getstudentdata('s_id',formdata);
      // this.objstudent=formdata;
      // this.objstudent.oprtype=cmd;
  
    }
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'xl'
     }
    this.modalRef=this.modalService.open(content,this.modalOptions);
   
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
      
    
  }
  
  
  openinfo(content,bkid)
  {
    this.getstudentdocs(bkid);
  this.masgeneral('Student Docs');
    this.stuid=bkid;
    // this.dcid=0;
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
     }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         // this.Asmtdetls(asid);
          this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }
  
  
  
  openprofile(content,bkid)
  {
    this.stuid=bkid;
    this.chartcatcirculation();
    
    this.dcid=0;
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
     }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         // this.Asmtdetls(asid);
          this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }
  
  
  ondoctypechange(e)
  {
  debugger;
  
    console.log('dcid',this.dcid);
    //console.log('isElementPresent1',this.arrstudoctype.length);
    if(this.arrstudoc==undefined || this.arrstudoc.length==0)
    {
      this.disuploadbtn=false;
    }
    else{
    const isElementPresent = this.arrstudoc.some((o) => o.dcid === this.dcid);
    console.log('isElementPresent',isElementPresent);
    
    if(isElementPresent)
    {
      this.disuploadbtn=true;
      alert('Photo/Document already present');
    }
    else
    {this.disuploadbtn=false;}
    }
  }
  
  upload(files: FileList) {
    debugger;
    this.fileToUpload = files.item(0);
  
    this.fData.append("bkid", this.stuid.toString());
    this.fData.append("dcid", this.dcid.toString());
    //this.fData.append("docpurpose", "Studentphoto");
  
    // this.SService.uploadFile(fData).subscribe(
    //     response => this.handleResponse(response),
    //     error => this.handleError(error)
    // )
    this.ondoctypechange(this.dcid);
  }
  
  fileupload()
  {
  debugger
  
  console.log('file data',JSON.stringify(this.fileToUpload));
  
  this.fservice.uploadmemberphoto(this.fileToUpload,this.stuid,this.dcid)
  .subscribe(fresult => {
     // console.log('ret',JSON.stringify(fresult));
      alert (fresult.message);
      if(fresult.status=='Success')
  {
  // let localmodref=this.modalRef;
  // localmodref.close();
  //this.Refreshsummary();
  this.fileToUpload=null;
  this.dcid=0;
  this.disuploadbtn=true;
  this.getstudentdocs(this.stuid);
  this.getstudents('s',0);
  }
      
  }, error => 
  alert('error in connection')
  
  );
  
  
  
  }
  
  
  getstudentdocs(stuid) {
    this.fservice.getstudentdocs(stuid)
        .subscribe(
        resultArray => {
            console.log('arrmtongue', resultArray);
            this.arrstudoc = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  delstudentdocs(rid,dcpath) {
    this.fservice.delstudentdocs(rid,dcpath)
        .subscribe(
        resultArray => {
            console.log('del', resultArray);
           // this.arrstudoc = resultArray;
           alert(resultArray.message);
           this.getstudentdocs(this.stuid);
           this.getstudents('s',0);
        },
        error => console.log("Error :: " + error)
        )
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  
   
  updatestudentbulk()
  {
    
    var result = confirm("Are you sure you want to modify details?");
  
    if(result)
    {
    this.fservice.updatestudentbulk(this.arrstulist,this.objfieldsel.fieldnm)
    .subscribe(result => {
        console.log('ret',JSON.stringify(result));
        alert (result.message);
        if(result.status=='Success')
  {
    
  //this.getstudents('s',0);
  
  }
        //this.alertmessage=result.message;
    
   // this.Getclasslist();
    }, error => 
    alert('error in connection')
  
    
    //this.alertmessage='error in connection'
    );
    }
  }
  
  getcerttypes() {
    this.fservice.getcerttypes()
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arrcerftypes = resultArray;
           this.defctype=resultArray[0].id;
           this.getcertformat(resultArray[0].id);
        },
        error => console.log("Error :: " + error)
        )
  }
  
  
  getcertformat(crid) {
    debugger
    var insid=localStorage.getItem('masclid')
    this.fservice.getcertformat(insid,crid)
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arrformats = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  
  
  notification() {
    this.fservice.stuprofile('notif',this.stuid)
        .subscribe(
        resultArray => {
            console.log('arrmtongue', resultArray);
           
  
            this.arrnotif = resultArray;
            
           
        },
        error => console.log("Error :: " + error)
        )
  }

  masadmyear() {
    this.mservice.masadmyear()
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arradmyr = resultArray;
          
        },
        error => console.log("Error :: " + error)
        )
  }

  }
  
  
